module.exports = __webpack_public_path__ + "static/img/dszx.69575cdb.jpg";